<template>
  <form novalidate @submit.prevent="send">
    <header class="modal-header">Let us know what the issue is</header>
    <section class="modal-body">
      <LsInput
        v-model="notes"
        :validation="{ required: true }"
        name="notes"
        type="textarea"
        track-id="return_request_notes-notes"
      />
    </section>
    <footer class="modal-footer">
      <LsButton
        type="submit"
        text="next"
        track-id="return_request_notes-next"
        :loading="dispute.loadingStatus.isUpdating"
      />
    </footer>
  </form>
</template>

<script>
import { LsButton, LsInput } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import {
  DISPUTE__UPDATE_CURRENT_DISPUTE,
  DISPUTE__OPEN_SUPPORT_TICKET,
  DISPUTE__SUBMIT_DISPUTE,
} from '@/store/types';

export default {
  name: 'ReturnRequestNotes',
  components: {
    LsButton,
    LsInput,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      notes: '',
    };
  },
  computed: {
    ...mapState(['dispute']),
  },
  methods: {
    ...mapActions([
      DISPUTE__UPDATE_CURRENT_DISPUTE,
      DISPUTE__OPEN_SUPPORT_TICKET,
      DISPUTE__SUBMIT_DISPUTE,
    ]),

    async send() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        return;
      }

      const { dispute_type } = this.dispute.currentDispute;

      if (dispute_type === 'scheduling_issue') {
        this[DISPUTE__UPDATE_CURRENT_DISPUTE]({
          notes: this.notes,
        });
        this[DISPUTE__OPEN_SUPPORT_TICKET]();
      } else {
        this[DISPUTE__UPDATE_CURRENT_DISPUTE]({
          notes: this.notes,
          currentStep: 'ReturnRequestPhotos',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
